import { IAppState } from '../../../../../AppModulesWrapper';
import { createSelector } from 'reselect';
import { selectTermsDurations } from './selectTermsDurations';
import { IDuration } from '../types';

export const selectTermsDurationInDays = createSelector(
  (state: IAppState) => selectTermsDurations(state),
  (durations: IDuration[]): number => {
    const activeDuration = durations.find(({ selected }) => selected);

    return activeDuration?.durationInDays || 1;
  },
);
